<template>
  <div class="OnboardingView container flex flex-col md-pt-56">
    <div class="mb-24 grid col-1 lg-col-2 pb-40">
      <div class="OnboardingView__left lg-pr-112">
        <template v-if="productionTip">
          <div>
            <img
              v-if="productionTip.Image"
              class="w-full hide md-d-block"
              :src="`${productionTip.Image.data.attributes.url}`"
              alt=""
            />
            <div class="hide lg-d-block">
              <h2 class="font-family-display font-weight-bold mb-24">
                {{ productionTip.Title }}
              </h2>
              <p>{{ productionTip.Text }}</p>
            </div>
          </div>
        </template>
      </div>
      <div class="OnboardingView__right pt-0">
        <h1 class="font-family-display font-weight-bold mb-8">
          {{ $t('register_artist_account') }}
        </h1>
        <p class="mb-24">
          {{ $t('already_have_an_account') }}
          <router-link :to="{ name: 'Login' }">
            {{ $t('login') }}
          </router-link>
        </p>
        <AccountOnboardingForm />
      </div>
    </div>
  </div>
</template>

<script setup>
import AccountOnboardingForm from '@/components/forms/AccountOnboardingForm.vue'
import { storeToRefs } from 'pinia'
import { useCmsStore } from '@/stores/cmsStore'

const cmsStore = useCmsStore()
const { productionTip } = storeToRefs(cmsStore)
</script>

<style lang="scss" scoped>
.OnboardingView {
  margin-top: 0;
  margin-bottom: 0;
}
</style>
